import React from 'react';
export const CFIconQuestionMark = {
    alias: 'question-mark',
    defaultTitle: 'Question Mark',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M12 4c2.757 0 5 2.243 5 5a5.007 5.007 0 0 1-4 4.898V15a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3a1 1 0 1 1-2 0c0-2.757 2.243-5 5-5Zm-1 15a1 1 0 1 1 2 0 1 1 0 1 1-2 0Z' }))),
};
